import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { ApplicationResponse } from "@src/common/domain/common.model"
import api from "@src/common/services/api.service"
import AppConstants from "@src/utils/app.constants"
import { CustomersStore, NewCustomerModelRef, } from "@src/views/customers/domain/customers.model"
export const addCustomerList = createAsyncThunk<void, any>("customer/addCustomer",
    async (payload: any) => {
        const response = await api.post<ApplicationResponse<NewCustomerModelRef[]>>(`${AppConstants.api}/customer`, payload)
    })
export const updateCustomerList = createAsyncThunk<void, any>("customer/updateCustomer",
    async (payload: any) => {
        const response = await api.put<ApplicationResponse<NewCustomerModelRef[]>>(`${AppConstants.api}/customer`, payload)
    })
export const deleteCustomer = createAsyncThunk(
    "customer/deleteCustomer",
    async (id: string) => {
        try {
            const response = await api.delete<ApplicationResponse<any[]>>(
                `${AppConstants.api}/customer?id=${id}`
            );
            return response.data.data || [];
        } catch (err) {
            return [];
        }
    }
);

export const deliveryLocationByCustomerList = createAsyncThunk<any[], any>("customer/deliveryLocationByCustomerList",

    async (id) => {

        const response = await api.get<ApplicationResponse<[]>>(`${AppConstants.api}/deliveryLocation/byCustomer?id=` + id)
        return response.data.data || []
    })
export const fetchCustomerList = createAsyncThunk<any[], void>("customer/fetchCustomer",
    async () => {
        const response = await api.get<ApplicationResponse<NewCustomerModelRef[]>>(`${AppConstants.api}/customer`)
        return response.data.data || []
    })
const customerSlice = createSlice({
    name: "customer",
    initialState: { minimal: { status: "loading", error: null, data: [] },
 deliveryLocationByCustomerminimal: { status: "loading", error: null, data: [] } } as CustomersStore,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCustomerList.pending, (state, action) => {
                state.minimal = {
                    status: "loading",
                    data: [],
                    error: null
                }
            })
            .addCase(fetchCustomerList.fulfilled, (state, action) => {
                state.minimal = {
                    status: "idle",
                    data: action.payload,
                    error: null
                }
            })
            .addCase(fetchCustomerList.rejected, (state, action) => {
                state.minimal = {
                    status: "failed",
                    data: [],
                    error: action.error
                }
            })
            .addCase(deliveryLocationByCustomerList.pending, (state, action) => {
                state.deliveryLocationByCustomerminimal = {
                    status: "loading",
                    data: [],
                    error: null
                }
            })
            .addCase(deliveryLocationByCustomerList.fulfilled, (state, action) => {
                state.deliveryLocationByCustomerminimal = {
                    status: "idle",
                    data: action.payload,
                    error: null
                }
            })
            .addCase(deliveryLocationByCustomerList.rejected, (state, action) => {
                state.deliveryLocationByCustomerminimal = {
                    status: "failed",
                    data: [],
                    error: action.error
                }
            })
    }
})

export default customerSlice.reducer
